<h1 mat-dialog-title>時刻選択</h1>

<div mat-dialog-content>
  <form class="select-time-form">
    <div class="input-form">
      <div class="date-radio">
        <label class="date-radio-button">
          <input type="radio" value="-1" name="dateDiff" [ngModel]="dateDiff" (ngModelChange)="dateDiffChange($event)">前日
        </label>
        <label class="date-radio-button">
          <input type="radio" value="0" name="dateDiff" [ngModel]="dateDiff" (ngModelChange)="dateDiffChange($event)" required>当日
        </label>
        <label class="date-radio-button">
          <input type="radio" value="1" name="dateDiff" [ngModel]="dateDiff" (ngModelChange)="dateDiffChange($event)">翌日
        </label>
      </div>
      <div class="input-time">
        <input type="time" step="60" name="time" [ngModel]="timeData | date: 'HH:mm'" (ngModelChange)="timeChange($event)">
      </div>
    </div>
    <div class="submit-button-form">
      <button type="cancel" (click)="onCancel()" mat-raised-button>Cancel</button>
      <button type="submit" (click)="onSubmit()" mat-raised-button color="primary">OK</button>
    </div>
  </form>
</div>
